import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { from, neutral, palette, space, visuallyHidden, } from '@guardian/source/foundations';
import { Column, Columns, SvgGuardianLogo, } from '@guardian/source/react-components';
import { Container } from 'components/layout/container';
const logoContainer = css `
	display: flex;
	justify-content: flex-end;
	margin-top: 6px;
	margin-bottom: 15px;
	height: 44px;

	${from.desktop} {
		margin-top: ${space[2]}px;
		height: 100px;
	}

	svg {
		height: 100%;
	}
`;
export function Header({ children }) {
    return (_jsx("header", { children: _jsx(Container, { backgroundColor: palette.brand[400], children: _jsxs(Columns, { children: [_jsx(Column, { children: children }), _jsx(Column, { span: [2, 3, 4], children: _jsxs("a", { href: "https://www.theguardian.com", css: logoContainer, children: [_jsx("div", { css: css `
									${visuallyHidden};
								`, children: "Return to the Guardian" }), _jsx(SvgGuardianLogo, { textColor: neutral[100] })] }) }), _jsx(Column, { span: [0, 0, 0, 0, 1] })] }) }) }));
}
